import {
  CollapsibleItem,
  PrimaryCaption,
  SecondaryCaption,
} from './WorkflowWebhookNameCell.styles';

export const FormUrlEncodedBody = ({ body }) => {
  if (!body || body.length === 0) {
    return <div>None</div>;
  }

  return (
    <div>
      {body.map((field) => (
        <CollapsibleItem key={field.key}>
          <PrimaryCaption>{field.key}</PrimaryCaption>
          <SecondaryCaption>{field.value}</SecondaryCaption>
        </CollapsibleItem>
      ))}
    </div>
  );
};
